import { deleteCategory as deleteCategoryAction } from '../../../actions/management/methods/delete-category'
import { responseHandlerService } from '@/plugins/responseHandlerService'

/**
 * Deletes a category
 * @param {Object} category - The category to delete
 * @param {string|number} assetId - The asset ID
 * @param {Function} i18n - Translation function
 * @returns {Object} - Result with success status
 */
export const deleteCategory = async (category, assetId, i18n) => {
  if (!category?.id) {
    const errorMessage = i18n ? i18n('settings.components.configuration.components.categoryModal.common.error.deleteCategory') : 'Invalid category'
    responseHandlerService.handleError(errorMessage)
    return { success: false, error: new Error(errorMessage) }
  }
  
  try {
    await deleteCategoryAction(category.id, assetId)
    
    const successMessage = i18n ? i18n('settings.components.configuration.components.categoryModal.common.success.deleted') : 'Category deleted successfully'
    responseHandlerService.handleSuccess(successMessage)
    
    return { 
      success: true, 
      deletedInfo: {
        id: category.id,
        parentId: category.custom_parent_id,
        level: category.level
      }
    }
  } catch (error) {
    responseHandlerService.handleError(error)
    return { success: false, error }
  }
}
